<template>
  <v-container fluid>
    <!-- Local de estoque -->
    <v-select
      v-model="selectedLocation"
      :items="locations"
      item-text="name"
      item-value="id"
      label="Local de Estoque"
      outlined
      dense
      class="mb-4"
      @change="buscarProdutosPorLocal"
    />

    <!-- Select para escolher produtos -->
    <v-select
      v-model="itemSelecionado"
      :items="produtos"
      item-text="name"
      item-value="id"
      label="Adicionar produto"
      dense
      outlined
      clearable
      return-object
      solo
      :menu-props="{ maxHeight: '300px' }"
      @change="adicionarAoCarrinho"
      class="mb-4"
    />

    <!-- Itens no carrinho -->
    <v-divider class="my-4" />
    <div v-if="carrinho.length > 0">
      <h4>Itens no carrinho</h4>
      <v-list two-line>
        <v-list-item v-for="(entry, index) in carrinho" :key="index">
          <v-list-item-content>
            <v-list-item-title>
              {{ entry.name }} (R$ {{ entry.price.toFixed(2) }})
            </v-list-item-title>
            Disponível: {{ entry.qtyEstoque }}
            <br />
            <v-list-item-subtitle>
              Quantidade:
              <v-btn icon small @click="entry.qty = Math.max(1, entry.qty - 1)">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              {{ entry.qty }}
              <v-btn icon small @click="aumentarQuantidade(entry)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="removerDoCarrinho(index)">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>

    <!-- Rodapé com total e botão -->
    <v-bottom-navigation fixed app height="64" style="bottom: 0">
      <v-container class="d-flex justify-space-between align-center pa-2">
        <div class="text-subtitle-1">
          Total: <strong>R$ {{ total.toFixed(2) }}</strong>
        </div>

        <v-btn dark elevation="2" height="48" large @click="abrirConfirmacao">
          Finalizar Venda
        </v-btn>
      </v-container>
    </v-bottom-navigation>

    <v-dialog v-model="dialogConfirmar" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmar Venda</v-card-title>
        <v-card-text>
          Tem certeza que deseja finalizar a venda com
          <strong>{{ carrinho.length }}</strong> item(s)?
          <div>
            Total: <strong>R$ {{ total.toFixed(2) }}</strong>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogConfirmar = false">Cancelar</v-btn>
          <v-btn color="#FF562B" @click="confirmarVenda" dark>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AlertaModal v-model="alerta" :mensagem="mensagem" :titulo="'Estoque'" />
  </v-container>
</template>

<script>
import { getStockBalances } from '../../services/estoque/estoque-servico';
import { getItems } from '../../services/estoque/item-servico';
import { getLocations } from '../../services/estoque/local-servico';
import { baixaItensEstoque } from '../../services/estoque/venda-servico';
import AlertaModal from '../Modais/AlertaModal.vue';
export default {
  name: 'VendaCarrinho',
  components: { AlertaModal },
  data() {
    return {
      produtos: [],
      alerta: false,
      mensagem: '',
      carrinho: [],
      locations: [],
      selectedLocation: null,
      dialogConfirmar: false,
    };
  },
  computed: {
    total() {
      return this.carrinho.reduce((acc, item) => acc + item.qty * item.price, 0);
    },
  },
  async mounted() {
    this.locations = await getLocations();
  },
  methods: {
    async buscarProdutosPorLocal() {
      if (!this.selectedLocation) return;

      try {
        const estoque = await getStockBalances(this.selectedLocation);
        this.produtos = estoque.map(item => ({
          id: item.item_id,
          name: item.item_name,
          price_sell: item.price_sell,
          qty: item.qty,
          category: item.category_name,
        }));
      } catch (e) {
        console.error('Erro ao buscar estoque:', e);
        this.$toast.error('Erro ao carregar produtos para o local selecionado.');
      }
    },
    aumentarQuantidade(item) {
      if (item.qty < item.qtyEstoque) {
        item.qty++;
      } else {
        this.alerta = true;
        this.mensagem = `Estoque máximo de ${item.qtyEstoque} atingido para ${item.name}`;
      }
    },

    abrirConfirmacao() {
      if (this.carrinho.length === 0) {
        this.$toast.error('Adicione ao menos um item');
        return;
      }
      this.dialogConfirmar = true;
    },
    adicionarAoCarrinho(produto) {
      if (!produto) return;

      const existente = this.carrinho.find(p => p.item_id === produto.id);
      if (existente) {
        existente.qty += 1;
      } else {
        this.carrinho.push({
          item_id: produto.id,
          name: produto.name,
          price: produto.price_sell,
          qty: 1,
          qtyEstoque: produto.qty,
        });
      }

      this.itemSelecionado = null; // limpa o select após adicionar
    },
    removerDoCarrinho(index) {
      this.carrinho.splice(index, 1);
    },
    async confirmarVenda() {
      this.dialogConfirmar = false;

      const payload = this.carrinho.map(item => ({
        item_id: item.item_id,
        qty: item.qty,
        movement_type: 'out',
        location_id: this.selectedLocation || 1,
        occurred_at: new Date().toISOString(),
        reference: 'Venda interna',
      }));

      try {
        const estoqueAtual = await getStockBalances(this.selectedLocation);

        const estoqueOk = this.carrinho.every(
          item => item.qty <= estoqueAtual.find(i => i.item_id === item.item_id).qty
        );
        if (!estoqueOk) {
          this.alerta = true;
          this.mensagem = 'Um ou mais itens excedem o estoque disponível.';
        }

        await baixaItensEstoque({ items: payload });

        this.alerta = true;
        this.mensagem = 'Baixa concluída com sucesso!';

        // Limpar o carrinho e resetar seleção
        this.carrinho = [];
        this.itemSelecionado = null;

        // Recarrega os itens do estoque (caso necessário mostrar quantidade futura)
        this.produtos = await getItems();

        // Volta o scroll para o topo em dispositivos móveis
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // (Opcional) foca no campo de item
        this.$nextTick(() => {
          const el = document.querySelector('.v-select input');
          if (el) el.focus();
        });
      } catch (err) {
        console.error(err);
        this.$toast.error('Erro ao registrar venda');
      }
    },
  },
};
</script>

<style scoped>
.v-bottom-navigation {
  z-index: 10;
}
</style>
